// extracted by mini-css-extract-plugin
export default {"theme_red":"theme_red__5+5qM","theme_purple":"theme_purple__z-pYz","theme_blue":"theme_blue__V8+8V","theme_green":"theme_green__kdiCq","theme_yellow":"theme_yellow__VN+wC"};